export default "__VITE_ASSET__hjH_45OF__"